export const FEEDBACK_URL = 'https://forms.gle/oUbCwUqneq1Z9jF16'
